/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useInfiniteQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface HistoricoPagination {
  currentPage: number;
  totalItemsPage: number;
  quantityPages: number;
  totalItems: number;
}

export interface HistoricoPage {
  data: any[];
  pagination?: HistoricoPagination;
}

export const useHistorico = ({
  idOportunidade,
  totalItensRetorno,
  palavraChave,
}: {
  idOportunidade: string;
  totalItensRetorno: number;
  palavraChave?: string;
}) => {
  const fetchPage = async ({ pageParam = 1 }): Promise<HistoricoPage> => {
    const url = `${backofficeEnviroment}/common/oportunidades-lead/historico/v1?IdOportunidade=${idOportunidade}&PaginaAtual=${pageParam}&TotalItensRetorno=${totalItensRetorno}${
      palavraChave ? `&PalavraChave=${encodeURIComponent(palavraChave)}` : ""
    }`;

    const response = await instance.get(url);

    return {
      data: Array.isArray(response?.data?.data) ? response.data.data : [],
      pagination: response?.data?.pagination,
    };
  };

  const query = useInfiniteQuery({
    queryFn: fetchPage,
    // `palavraChave` faz parte da chave: buscas diferentes não compartilham
    // cache nem paginação. A página NÃO entra na chave — quem controla isso
    // é o próprio useInfiniteQuery.
    queryKey: ["get-historico", idOportunidade, palavraChave ?? ""],
    enabled: !!idOportunidade,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) => {
      const current = lastPage?.pagination?.currentPage ?? 0;
      const totalPages = lastPage?.pagination?.quantityPages ?? 0;

      if (current && totalPages) {
        return current < totalPages ? current + 1 : undefined;
      }

      // Fallback sem metadados de paginação: só continua enquanto a API
      // devolver páginas cheias. Página incompleta = fim da lista, o que
      // evita loop infinito de requisições.
      const isFullPage = lastPage?.data?.length === totalItensRetorno;
      return isFullPage ? allPages.length + 1 : undefined;
    },
  });

  const pages = query.data?.pages ?? [];
  const historico = pages.reduce<any[]>(
    (acc, page) => acc.concat(page?.data ?? []),
    []
  );
  const pagination = pages.length
    ? pages[pages.length - 1]?.pagination
    : undefined;

  return { ...query, historico, pagination };
};
